import {Injectable} from '@angular/core';
import {BackOfficeConfig} from "../interfaces/back-office-config";
import {catchError, of, take} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  targetStorage: string = '';
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig


  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  initializeTranslations(): Promise<boolean> {
    this.backofficeConfig = this.configService.getBackOfficeConfig();
    this.targetStorage = this.backofficeConfig['FLEET_TRANSLATION_TARGET_ON_LOCAL_STORAGE'];
    const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;

    let translationUrl: string;

    switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
      case 'LOCAL':
        translationUrl = `http://localhost:3000/getTranslation/${culture}`;
        break;
      case 'BUCKET':
        translationUrl = `/fakeoffice/translations/translation_${culture}.json`;
        break;
      case 'BACKOFFICE':
        const isProduction = process.env['BO_ENV'] === "backoffice-prod";
        const domain = isProduction ? 'settings.spacemdw.com' : 'settings.int.spacemdw.com';
        translationUrl = `https://${domain}/?brand=xx&culture=${culture}&source=fleet&featurename=localization`;
        break;
      default:
        return Promise.resolve(false);
    }

    return new Promise<boolean>((resolve, reject) => {
      this.http.get(translationUrl).pipe(
        take(1),
        catchError(error => {
          console.error('Failed to load translations:', error);
          reject(error);
          return of(null);
        })
      ).subscribe(value => {
        if (value) {
          localStorage.setItem(this.targetStorage, JSON.stringify(value));
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getTranslationForPage(pageName: string): Object {
    const translationFleet = JSON.parse(localStorage.getItem(this.targetStorage) + "");
    if (translationFleet){
      return Object.keys(translationFleet)
        .filter(key => key.split('.')[0] === pageName)
        .reduce((result: any, key: string) => {
          if (translationFleet != null) {
            result[key] = translationFleet[key];
          }
          return result;
        }, {} as { [key: string]: string });
    }
    return {}
  }
}
